<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title">
            <h5><i class="fa fa-user"></i>&nbsp;Futur propriétaire</h5>
          </div>
          <div class="ibox-content">
            <div class="owner-wizard">
              <ul class="steps">
                <li v-for="(step, index) in steps"
                    :key="index"
                    :class="[index + 1 === activeStep ? 'active' : 'allowed']"
                    @click="toggleBlock(index + 1)">{{ index + 1 }}. {{ step }}</li>
              </ul>
              <keep-alive v-if="activeStep !== 2">
                <component v-if="futureOwner"
                           :is="component"
                           :owner-information="futureOwner"
                           :command="command"
                           :buyer="buyer"
                           :is-current-owner="false"/>
              </keep-alive>
              <documents v-else-if="futureOwner"
                         :command="command"
                         :is-current-owner="false"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import Identite from '../../components/details/proprietaire/Identite'
  import Documents from '../../components/details/proprietaire/Documents'

  export default {
    props: {
      command: {
        type: Object,
        required: true
      }
    },

    components: {
      'identite': Identite,
      'documents': Documents,
    },

    data: () => ({
      blocks: [
        'identite',
        'documents'
      ],
      steps: [
        'Identité',
        'Documents'
      ],
      activeStep: 1,
      futureOwner: null
    }),

    computed: {
      component () {
        return this.blocks[this.activeStep - 1]
      },

      commandId () {
        return this.$route.params.id
      },

      seller () {
        return this.command.seller[0]
      },

      buyer () {
        return this.command.buyer[0]
      },

      futureOwnerInformationsQuery () {
        return gql`
        query{
          futureOwner(orderId:"${this.commandId}") {
            isBuyerOwner
            hasCoOwner
            owner{
              civility
              firstName
              lastName
              usedName
              firstNameCo
              lastNameCo
              usedNameCo
              civilityCo
              ownerType
              companyName
              siretNumber
              birthDate
              birthPlace
              documentId
              iban
              address {
                address
                city
                zipCode
              }
            }
          }
        }`
      }
    },

    methods: {
      toggleBlock (step) {
        this.activeStep = step
      }
    },

    apollo: {
      futureOwner: {
        query () {
          return this.futureOwnerInformationsQuery
        }
      }
    }
  }
</script>
